export const SIZE_TO_SET_IMG_SMALL = 125;
export const MIN_CROP_SIZE = 30;

export enum CropRatio {
  Default = 1,
  SplashScreen = 7 / 10,
}
